/* eslint-disable */
// Arquivo gerado automaticamente por scripts/sync-icons.mjs.
// Não edite manualmente: rode `npm run icons:sync` após adicionar/remover ícones.
import {
  Icon360,
  IconActivity,
  IconAdjustments,
  IconAdjustmentsAlt,
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertTriangle,
  IconAlignCenter,
  IconAlignJustified,
  IconAlignLeft,
  IconAlignRight,
  IconAngle,
  IconArrowAutofitHeight,
  IconArrowAutofitWidth,
  IconArrowBack,
  IconArrowBackUp,
  IconArrowBarToDown,
  IconArrowBarToLeft,
  IconArrowBarToRight,
  IconArrowBarToUp,
  IconArrowDown,
  IconArrowForwardUp,
  IconArrowLeft,
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconArrowRight,
  IconArrowUp,
  IconArrowsExchange,
  IconArrowsMaximize,
  IconArrowsMoveHorizontal,
  IconArrowsMoveVertical,
  IconArrowsSort,
  IconArticle,
  IconAt,
  IconAward,
  IconAxisX,
  IconAxisY,
  IconBackground,
  IconBadge,
  IconBadgeCc,
  IconBan,
  IconBatteryCharging2,
  IconBell,
  IconBlob,
  IconBlur,
  IconBold,
  IconBook,
  IconBookmark,
  IconBookmarkFilled,
  IconBookmarks,
  IconBrandLinkedin,
  IconBrandYoutube,
  IconBrowserPlus,
  IconBubble,
  IconBuildingSkyscraper,
  IconBulb,
  IconCalendar,
  IconCalendarCheck,
  IconCalendarClock,
  IconCalendarEvent,
  IconCalendarExclamation,
  IconCalendarMonth,
  IconCalendarSmile,
  IconCamera,
  IconCancel,
  IconCapture,
  IconCards,
  IconCaretDown,
  IconCarouselHorizontal,
  IconCategory,
  IconCell,
  IconCertificate,
  IconChartBarPopular,
  IconChartHistogram,
  IconChartLine,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconCheckupList,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsDown,
  IconChevronsLeft,
  IconChevronsRight,
  IconCircle,
  IconCircleArrowDownFilled,
  IconCircleArrowUpFilled,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDashedPlus,
  IconCircleDot,
  IconCircleDotFilled,
  IconCircleX,
  IconCircleXFilled,
  IconClick,
  IconClipboard,
  IconClipboardCheck,
  IconClipboardPlus,
  IconClipboardText,
  IconClock,
  IconClockExclamation,
  IconClockHour5,
  IconCloudDownload,
  IconCloudOff,
  IconCloudUpload,
  IconCode,
  IconCoin,
  IconColorPicker,
  IconColumns,
  IconCompass,
  IconConfetti,
  IconContainer,
  IconContract,
  IconContrast,
  IconCopy,
  IconCopyPlus,
  IconCsv,
  IconCube,
  IconCurrency,
  IconDashboard,
  IconDecimal,
  IconDeselect,
  IconDetails,
  IconDeviceDesktop,
  IconDeviceFloppy,
  IconDeviceGamepad,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTv,
  IconDevicesExclamation,
  IconDiamond,
  IconDisabled,
  IconDoorExit,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconDragDrop,
  IconEdit,
  IconEqual,
  IconExclamationCircle,
  IconExclamationMark,
  IconExternalLink,
  IconEye,
  IconEyeCheck,
  IconEyeClosed,
  IconEyeOff,
  IconFile,
  IconFileAlert,
  IconFileAnalytics,
  IconFileCertificate,
  IconFileCheck,
  IconFileDatabase,
  IconFileDownload,
  IconFileIsr,
  IconFileMusic,
  IconFilePencil,
  IconFileSearch,
  IconFileSettings,
  IconFileSpreadsheet,
  IconFileText,
  IconFileTypePdf,
  IconFileTypeZip,
  IconFileUnknown,
  IconFileUpload,
  IconFileX,
  IconFileZip,
  IconFiles,
  IconFilter,
  IconFilter2,
  IconFilterFilled,
  IconFilters,
  IconFlag,
  IconFlagCheck,
  IconFocus,
  IconFolder,
  IconFolderOpen,
  IconFreezeColumn,
  IconFreezeRow,
  IconFunction,
  IconGhost,
  IconGift,
  IconGlass,
  IconGolf,
  IconGraph,
  IconGridDots,
  IconGripVertical,
  IconH4,
  IconHandClick,
  IconHash,
  IconHeading,
  IconHeadphones,
  IconHeart,
  IconHelpCircle,
  IconHistory,
  IconHome,
  IconHomeCancel,
  IconHomeCheck,
  IconHourglass,
  IconHtml,
  IconId,
  IconInfinity,
  IconInfoCircle,
  IconInfoTriangle,
  IconItalic,
  IconJpg,
  IconKey,
  IconLabel,
  IconLanguage,
  IconLayersSelected,
  IconLayersSelectedBottom,
  IconLayoutDashboard,
  IconLayoutGrid,
  IconLayoutGridAdd,
  IconLayoutList,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconLayoutSidebarRightInactive,
  IconLibrary,
  IconLibraryPlus,
  IconLicense,
  IconLine,
  IconLink,
  IconLinkPlus,
  IconList,
  IconListCheck,
  IconListDetails,
  IconListLetters,
  IconListNumbers,
  IconListSearch,
  IconListTree,
  IconLoader,
  IconLoader2,
  IconLock,
  IconLockCheck,
  IconLockOpen,
  IconLockQuestion,
  IconLockSquareRounded,
  IconLockX,
  IconLogin,
  IconLogout,
  IconMap,
  IconMarkdown,
  IconMask,
  IconMathAvg,
  IconMathSymbols,
  IconMatrix,
  IconMaximize,
  IconMedal,
  IconMenu,
  IconMenu2,
  IconMenuOrder,
  IconMessage,
  IconMessageDots,
  IconMessageReport,
  IconMicrophone,
  IconMinimize,
  IconMinus,
  IconMoodAngry,
  IconMoodEmpty,
  IconMoodHappy,
  IconMoodPuzzled,
  IconMoodSad,
  IconMoodSmile,
  IconMoodSuprised,
  IconMoon,
  IconMusic,
  IconNavigation,
  IconNetwork,
  IconNotebook,
  IconNotes,
  IconNumber,
  IconNumbers,
  IconOption,
  IconPackage,
  IconPackages,
  IconPaperclip,
  IconPassword,
  IconPasswordUser,
  IconPdf,
  IconPencil,
  IconPercentage,
  IconPhone,
  IconPhoto,
  IconPhotoFilled,
  IconPhotoPlus,
  IconPhotoUp,
  IconPin,
  IconPlaceholder,
  IconPlayerPauseFilled,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconPlaylistAdd,
  IconPlugConnectedX,
  IconPlus,
  IconPng,
  IconPresentation,
  IconPrinter,
  IconProgress,
  IconProgressCheck,
  IconQrcode,
  IconQuestionMark,
  IconQuote,
  IconRadio,
  IconRefresh,
  IconReload,
  IconRepeat,
  IconReplaceUser,
  IconReport,
  IconReportAnalytics,
  IconResize,
  IconRestore,
  IconRocket,
  IconRotate,
  IconRotate360,
  IconRotateClockwise,
  IconRotateRectangle,
  IconRoute,
  IconScale,
  IconSchool,
  IconScript,
  IconSearch,
  IconSearchOff,
  IconSection,
  IconSelect,
  IconSelectAll,
  IconSelector,
  IconSend,
  IconSend2,
  IconSeparator,
  IconSeparatorHorizontal,
  IconSettings,
  IconSettingsSpark,
  IconShape,
  IconShare,
  IconSlideshow,
  IconSortAscendingLetters,
  IconSortDescending,
  IconSortDescendingLetters,
  IconSparkle,
  IconSparkles,
  IconSparklesFilled,
  IconSquare,
  IconSquareCheck,
  IconSquarePlus,
  IconSquareRounded,
  IconSquareRoundedCheck,
  IconSquareRoundedMinus,
  IconStack,
  IconStar,
  IconStars,
  IconStopwatch,
  IconStrikethrough,
  IconSubtitles,
  IconSum,
  IconSun,
  IconSunHigh,
  IconSvg,
  IconTable,
  IconTableExport,
  IconTabs,
  IconTag,
  IconTarget,
  IconTemplate,
  IconTextPlus,
  IconThumbDown,
  IconThumbUp,
  IconToggleLeft,
  IconToggleLeftFilled,
  IconToggleRight,
  IconToggleRightFilled,
  IconTool,
  IconTooltip,
  IconTrack,
  IconTransform,
  IconTrash,
  IconTrendingUp,
  IconTrophy,
  IconUnderline,
  IconUpload,
  IconUrgent,
  IconUser,
  IconUserCircle,
  IconUserShield,
  IconUsers,
  IconUsersGroup,
  IconVideo,
  IconVideoPlus,
  IconViewportNarrow,
  IconViewportWide,
  IconVocabulary,
  IconVolume,
  IconVolume2,
  IconVolume3,
  IconWorldCheck,
  IconWriting,
  IconX,
  IconZip,
  IconZoomIn,
  IconZoomOut,
  IconZoomScan,
} from '@tabler/icons-vue'
import type { Component } from 'vue'

export const iconRegistry: Record<string, Component> = {
  '360': Icon360,
  'activity': IconActivity,
  'adjustments': IconAdjustments,
  'adjustments-alt': IconAdjustmentsAlt,
  'adjustments-horizontal': IconAdjustmentsHorizontal,
  'alert-circle': IconAlertCircle,
  'alert-triangle': IconAlertTriangle,
  'align-center': IconAlignCenter,
  'align-justified': IconAlignJustified,
  'align-left': IconAlignLeft,
  'align-right': IconAlignRight,
  'angle': IconAngle,
  'arrow-autofit-height': IconArrowAutofitHeight,
  'arrow-autofit-width': IconArrowAutofitWidth,
  'arrow-back': IconArrowBack,
  'arrow-back-up': IconArrowBackUp,
  'arrow-bar-to-down': IconArrowBarToDown,
  'arrow-bar-to-left': IconArrowBarToLeft,
  'arrow-bar-to-right': IconArrowBarToRight,
  'arrow-bar-to-up': IconArrowBarToUp,
  'arrow-down': IconArrowDown,
  'arrow-forward-up': IconArrowForwardUp,
  'arrow-left': IconArrowLeft,
  'arrow-narrow-left': IconArrowNarrowLeft,
  'arrow-narrow-right': IconArrowNarrowRight,
  'arrow-right': IconArrowRight,
  'arrow-up': IconArrowUp,
  'arrows-exchange': IconArrowsExchange,
  'arrows-maximize': IconArrowsMaximize,
  'arrows-move-horizontal': IconArrowsMoveHorizontal,
  'arrows-move-vertical': IconArrowsMoveVertical,
  'arrows-sort': IconArrowsSort,
  'article': IconArticle,
  'at': IconAt,
  'award': IconAward,
  'axis-x': IconAxisX,
  'axis-y': IconAxisY,
  'background': IconBackground,
  'badge': IconBadge,
  'badge-cc': IconBadgeCc,
  'ban': IconBan,
  'battery-charging-2': IconBatteryCharging2,
  'bell': IconBell,
  'blob': IconBlob,
  'blur': IconBlur,
  'bold': IconBold,
  'book': IconBook,
  'bookmark': IconBookmark,
  'bookmark-filled': IconBookmarkFilled,
  'bookmarks': IconBookmarks,
  'brand-linkedin': IconBrandLinkedin,
  'brand-youtube': IconBrandYoutube,
  'browser-plus': IconBrowserPlus,
  'bubble': IconBubble,
  'building-skyscraper': IconBuildingSkyscraper,
  'bulb': IconBulb,
  'calendar': IconCalendar,
  'calendar-check': IconCalendarCheck,
  'calendar-clock': IconCalendarClock,
  'calendar-event': IconCalendarEvent,
  'calendar-exclamation': IconCalendarExclamation,
  'calendar-month': IconCalendarMonth,
  'calendar-smile': IconCalendarSmile,
  'camera': IconCamera,
  'cancel': IconCancel,
  'capture': IconCapture,
  'cards': IconCards,
  'caret-down': IconCaretDown,
  'carousel-horizontal': IconCarouselHorizontal,
  'category': IconCategory,
  'cell': IconCell,
  'certificate': IconCertificate,
  'chart-bar-popular': IconChartBarPopular,
  'chart-histogram': IconChartHistogram,
  'chart-line': IconChartLine,
  'check': IconCheck,
  'checkbox': IconCheckbox,
  'checklist': IconChecklist,
  'checkup-list': IconCheckupList,
  'chevron-down': IconChevronDown,
  'chevron-left': IconChevronLeft,
  'chevron-right': IconChevronRight,
  'chevron-up': IconChevronUp,
  'chevrons-down': IconChevronsDown,
  'chevrons-left': IconChevronsLeft,
  'chevrons-right': IconChevronsRight,
  'circle': IconCircle,
  'circle-arrow-down-filled': IconCircleArrowDownFilled,
  'circle-arrow-up-filled': IconCircleArrowUpFilled,
  'circle-check': IconCircleCheck,
  'circle-check-filled': IconCircleCheckFilled,
  'circle-dashed-plus': IconCircleDashedPlus,
  'circle-dot': IconCircleDot,
  'circle-dot-filled': IconCircleDotFilled,
  'circle-x': IconCircleX,
  'circle-x-filled': IconCircleXFilled,
  'click': IconClick,
  'clipboard': IconClipboard,
  'clipboard-check': IconClipboardCheck,
  'clipboard-plus': IconClipboardPlus,
  'clipboard-text': IconClipboardText,
  'clock': IconClock,
  'clock-exclamation': IconClockExclamation,
  'clock-hour-5': IconClockHour5,
  'cloud-download': IconCloudDownload,
  'cloud-off': IconCloudOff,
  'cloud-upload': IconCloudUpload,
  'code': IconCode,
  'coin': IconCoin,
  'color-picker': IconColorPicker,
  'columns': IconColumns,
  'compass': IconCompass,
  'confetti': IconConfetti,
  'container': IconContainer,
  'contract': IconContract,
  'contrast': IconContrast,
  'copy': IconCopy,
  'copy-plus': IconCopyPlus,
  'csv': IconCsv,
  'cube': IconCube,
  'currency': IconCurrency,
  'dashboard': IconDashboard,
  'decimal': IconDecimal,
  'deselect': IconDeselect,
  'details': IconDetails,
  'device-desktop': IconDeviceDesktop,
  'device-floppy': IconDeviceFloppy,
  'device-gamepad': IconDeviceGamepad,
  'device-laptop': IconDeviceLaptop,
  'device-mobile': IconDeviceMobile,
  'device-tv': IconDeviceTv,
  'devices-exclamation': IconDevicesExclamation,
  'diamond': IconDiamond,
  'disabled': IconDisabled,
  'door-exit': IconDoorExit,
  'dots': IconDots,
  'dots-vertical': IconDotsVertical,
  'download': IconDownload,
  'drag-drop': IconDragDrop,
  'edit': IconEdit,
  'equal': IconEqual,
  'exclamation-circle': IconExclamationCircle,
  'exclamation-mark': IconExclamationMark,
  'external-link': IconExternalLink,
  'eye': IconEye,
  'eye-check': IconEyeCheck,
  'eye-closed': IconEyeClosed,
  'eye-off': IconEyeOff,
  'file': IconFile,
  'file-alert': IconFileAlert,
  'file-analytics': IconFileAnalytics,
  'file-certificate': IconFileCertificate,
  'file-check': IconFileCheck,
  'file-database': IconFileDatabase,
  'file-download': IconFileDownload,
  'file-isr': IconFileIsr,
  'file-music': IconFileMusic,
  'file-pencil': IconFilePencil,
  'file-search': IconFileSearch,
  'file-settings': IconFileSettings,
  'file-spreadsheet': IconFileSpreadsheet,
  'file-text': IconFileText,
  'file-type-pdf': IconFileTypePdf,
  'file-type-zip': IconFileTypeZip,
  'file-unknown': IconFileUnknown,
  'file-upload': IconFileUpload,
  'file-x': IconFileX,
  'file-zip': IconFileZip,
  'files': IconFiles,
  'filter': IconFilter,
  'filter-2': IconFilter2,
  'filter-filled': IconFilterFilled,
  'filters': IconFilters,
  'flag': IconFlag,
  'flag-check': IconFlagCheck,
  'focus': IconFocus,
  'folder': IconFolder,
  'folder-open': IconFolderOpen,
  'freeze-column': IconFreezeColumn,
  'freeze-row': IconFreezeRow,
  'function': IconFunction,
  'ghost': IconGhost,
  'gift': IconGift,
  'glass': IconGlass,
  'golf': IconGolf,
  'graph': IconGraph,
  'grid-dots': IconGridDots,
  'grip-vertical': IconGripVertical,
  'h-4': IconH4,
  'hand-click': IconHandClick,
  'hash': IconHash,
  'heading': IconHeading,
  'headphones': IconHeadphones,
  'heart': IconHeart,
  'help-circle': IconHelpCircle,
  'history': IconHistory,
  'home': IconHome,
  'home-cancel': IconHomeCancel,
  'home-check': IconHomeCheck,
  'hourglass': IconHourglass,
  'html': IconHtml,
  'id': IconId,
  'infinity': IconInfinity,
  'info-circle': IconInfoCircle,
  'info-triangle': IconInfoTriangle,
  'italic': IconItalic,
  'jpg': IconJpg,
  'key': IconKey,
  'label': IconLabel,
  'language': IconLanguage,
  'layers-selected': IconLayersSelected,
  'layers-selected-bottom': IconLayersSelectedBottom,
  'layout-dashboard': IconLayoutDashboard,
  'layout-grid': IconLayoutGrid,
  'layout-grid-add': IconLayoutGridAdd,
  'layout-list': IconLayoutList,
  'layout-sidebar-left-collapse': IconLayoutSidebarLeftCollapse,
  'layout-sidebar-left-expand': IconLayoutSidebarLeftExpand,
  'layout-sidebar-right-collapse': IconLayoutSidebarRightCollapse,
  'layout-sidebar-right-expand': IconLayoutSidebarRightExpand,
  'layout-sidebar-right-inactive': IconLayoutSidebarRightInactive,
  'library': IconLibrary,
  'library-plus': IconLibraryPlus,
  'license': IconLicense,
  'line': IconLine,
  'link': IconLink,
  'link-plus': IconLinkPlus,
  'list': IconList,
  'list-check': IconListCheck,
  'list-details': IconListDetails,
  'list-letters': IconListLetters,
  'list-numbers': IconListNumbers,
  'list-search': IconListSearch,
  'list-tree': IconListTree,
  'loader': IconLoader,
  'loader-2': IconLoader2,
  'lock': IconLock,
  'lock-check': IconLockCheck,
  'lock-open': IconLockOpen,
  'lock-question': IconLockQuestion,
  'lock-square-rounded': IconLockSquareRounded,
  'lock-x': IconLockX,
  'login': IconLogin,
  'logout': IconLogout,
  'map': IconMap,
  'markdown': IconMarkdown,
  'mask': IconMask,
  'math-avg': IconMathAvg,
  'math-symbols': IconMathSymbols,
  'matrix': IconMatrix,
  'maximize': IconMaximize,
  'medal': IconMedal,
  'menu': IconMenu,
  'menu-2': IconMenu2,
  'menu-order': IconMenuOrder,
  'message': IconMessage,
  'message-dots': IconMessageDots,
  'message-report': IconMessageReport,
  'microphone': IconMicrophone,
  'minimize': IconMinimize,
  'minus': IconMinus,
  'mood-angry': IconMoodAngry,
  'mood-empty': IconMoodEmpty,
  'mood-happy': IconMoodHappy,
  'mood-puzzled': IconMoodPuzzled,
  'mood-sad': IconMoodSad,
  'mood-smile': IconMoodSmile,
  'mood-suprised': IconMoodSuprised,
  'moon': IconMoon,
  'music': IconMusic,
  'navigation': IconNavigation,
  'network': IconNetwork,
  'notebook': IconNotebook,
  'notes': IconNotes,
  'number': IconNumber,
  'numbers': IconNumbers,
  'option': IconOption,
  'package': IconPackage,
  'packages': IconPackages,
  'paperclip': IconPaperclip,
  'password': IconPassword,
  'password-user': IconPasswordUser,
  'pdf': IconPdf,
  'pencil': IconPencil,
  'percentage': IconPercentage,
  'phone': IconPhone,
  'photo': IconPhoto,
  'photo-filled': IconPhotoFilled,
  'photo-plus': IconPhotoPlus,
  'photo-up': IconPhotoUp,
  'pin': IconPin,
  'placeholder': IconPlaceholder,
  'player-pause-filled': IconPlayerPauseFilled,
  'player-play': IconPlayerPlay,
  'player-play-filled': IconPlayerPlayFilled,
  'playlist-add': IconPlaylistAdd,
  'plug-connected-x': IconPlugConnectedX,
  'plus': IconPlus,
  'png': IconPng,
  'presentation': IconPresentation,
  'printer': IconPrinter,
  'progress': IconProgress,
  'progress-check': IconProgressCheck,
  'qrcode': IconQrcode,
  'question-mark': IconQuestionMark,
  'quote': IconQuote,
  'radio': IconRadio,
  'refresh': IconRefresh,
  'reload': IconReload,
  'repeat': IconRepeat,
  'replace-user': IconReplaceUser,
  'report': IconReport,
  'report-analytics': IconReportAnalytics,
  'resize': IconResize,
  'restore': IconRestore,
  'rocket': IconRocket,
  'rotate': IconRotate,
  'rotate-360': IconRotate360,
  'rotate-clockwise': IconRotateClockwise,
  'rotate-rectangle': IconRotateRectangle,
  'route': IconRoute,
  'scale': IconScale,
  'school': IconSchool,
  'script': IconScript,
  'search': IconSearch,
  'search-off': IconSearchOff,
  'section': IconSection,
  'select': IconSelect,
  'select-all': IconSelectAll,
  'selector': IconSelector,
  'send': IconSend,
  'send-2': IconSend2,
  'separator': IconSeparator,
  'separator-horizontal': IconSeparatorHorizontal,
  'settings': IconSettings,
  'settings-spark': IconSettingsSpark,
  'shape': IconShape,
  'share': IconShare,
  'slideshow': IconSlideshow,
  'sort-ascending-letters': IconSortAscendingLetters,
  'sort-descending': IconSortDescending,
  'sort-descending-letters': IconSortDescendingLetters,
  'sparkle': IconSparkle,
  'sparkles': IconSparkles,
  'sparkles-filled': IconSparklesFilled,
  'square': IconSquare,
  'square-check': IconSquareCheck,
  'square-plus': IconSquarePlus,
  'square-rounded': IconSquareRounded,
  'square-rounded-check': IconSquareRoundedCheck,
  'square-rounded-minus': IconSquareRoundedMinus,
  'stack': IconStack,
  'star': IconStar,
  'stars': IconStars,
  'stopwatch': IconStopwatch,
  'strikethrough': IconStrikethrough,
  'subtitles': IconSubtitles,
  'sum': IconSum,
  'sun': IconSun,
  'sun-high': IconSunHigh,
  'svg': IconSvg,
  'table': IconTable,
  'table-export': IconTableExport,
  'tabs': IconTabs,
  'tag': IconTag,
  'target': IconTarget,
  'template': IconTemplate,
  'text-plus': IconTextPlus,
  'thumb-down': IconThumbDown,
  'thumb-up': IconThumbUp,
  'toggle-left': IconToggleLeft,
  'toggle-left-filled': IconToggleLeftFilled,
  'toggle-right': IconToggleRight,
  'toggle-right-filled': IconToggleRightFilled,
  'tool': IconTool,
  'tooltip': IconTooltip,
  'track': IconTrack,
  'transform': IconTransform,
  'trash': IconTrash,
  'trending-up': IconTrendingUp,
  'trophy': IconTrophy,
  'underline': IconUnderline,
  'upload': IconUpload,
  'urgent': IconUrgent,
  'user': IconUser,
  'user-circle': IconUserCircle,
  'user-shield': IconUserShield,
  'users': IconUsers,
  'users-group': IconUsersGroup,
  'video': IconVideo,
  'video-plus': IconVideoPlus,
  'viewport-narrow': IconViewportNarrow,
  'viewport-wide': IconViewportWide,
  'vocabulary': IconVocabulary,
  'volume': IconVolume,
  'volume-2': IconVolume2,
  'volume-3': IconVolume3,
  'world-check': IconWorldCheck,
  'writing': IconWriting,
  'x': IconX,
  'zip': IconZip,
  'zoom-in': IconZoomIn,
  'zoom-out': IconZoomOut,
  'zoom-scan': IconZoomScan,
}
